import { HttpService, Repository, RepositoryBase, Tags, Weaver } from '@skylab-shared/core';
import { ProductGroupModel } from '@skylab-shared/dataModel';
import { pickBy } from '@skylab-shared/utils';
import { dictionaryRepositoryResponseHandler } from '../dictionary/dictionary-repository-response-handler';
import { ProductGroupBO } from './product-group.bo';

@Repository({
    boType: ProductGroupBO,
    apiController: {
        base: 'products/groups',
        get: '/:externalId',
        put: '/:externalId',
        delete: '/:externalId',
        tags: [Tags.Api]
    },
    responseHandler: dictionaryRepositoryResponseHandler,
})
export class ProductGroupRepositoryBase extends RepositoryBase<ProductGroupBO, ProductGroupModel> {
    public constructor(
        http: HttpService,
        private readonly weaver: Weaver
    ) {
        super(http);
    }

    protected createBO(): ProductGroupBO {
        return new ProductGroupBO(this.weaver);
    }

    protected async preparePlainObjectAsync(model: ProductGroupModel): Promise<any> {
        return {
            externalId: model.externalId,
            version: model.version,
            sun: model.sun,
            isDefault: model.isDefault,
            name: model.name
        };
    }

    protected async fromPlainObjectAsync(item: any): Promise<ProductGroupModel> {
        return new ProductGroupModel(pickBy({
            externalId: item.externalId,
            version: item.version,
            sun: item.sun,
            isDefault: item.isDefault,
            name: item.name,
        }, val => val !== void 0));
    }
}
